webpackJsonp([33747463168993],{

/***/ "./src/assets/labcoat.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/labcoat.543bbff8.png";

/***/ }),

/***/ "./src/components/atoms/SocialTags.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.MetaTags = undefined;
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _labcoat = __webpack_require__("./src/assets/labcoat.png");
	
	var _labcoat2 = _interopRequireDefault(_labcoat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MetaTags = exports.MetaTags = function MetaTags(_ref) {
	  var title = _ref.title,
	      description = _ref.description,
	      _ref$src = _ref.src,
	      src = _ref$src === undefined ? _labcoat2.default : _ref$src;
	  return [_react2.default.createElement("meta", { key: "title", property: "og:title", content: title }), _react2.default.createElement("meta", { key: "title", property: "og:description", content: description }), _react2.default.createElement("meta", { property: "og:image", content: src }), _react2.default.createElement("meta", { name: "twitter:title", content: title }), _react2.default.createElement("meta", { name: "twitter:description", content: description }), _react2.default.createElement("meta", { name: "twitter:image", content: src }), _react2.default.createElement("meta", { name: "twitter:card", content: "summary_large_image" })];
	};

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"presets\":[\"/opt/build/repo/node_modules/babel-preset-react-app/index.js\",[\"/opt/build/repo/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"IE >= 9\",\"Safari >= 9\",\"last 2 versions\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/opt/build/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\",[\"/opt/build/repo/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"IE >= 9\",\"Safari >= 9\",\"last 2 versions\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/opt/build/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\"],\"plugins\":[\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/opt/build/repo/node_modules/react-hot-loader/babel.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/news/post.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactMarkdown = __webpack_require__("./node_modules/react-markdown/src/react-markdown.js");
	
	var _reactMarkdown2 = _interopRequireDefault(_reactMarkdown);
	
	var _NavBar = __webpack_require__("./src/components/NavBar.js");
	
	var _NavBar2 = _interopRequireDefault(_NavBar);
	
	var _ArrowLink = __webpack_require__("./src/components/ArrowLink.js");
	
	var _typography = __webpack_require__("./src/components/typography/index.js");
	
	var _Section = __webpack_require__("./src/components/blocks/Section.js");
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Responsive = __webpack_require__("./src/components/blocks/Responsive.js");
	
	var _Flex = __webpack_require__("./src/components/blocks/Flex.js");
	
	var _Flex2 = _interopRequireDefault(_Flex);
	
	var _Pad = __webpack_require__("./src/components/blocks/Pad.js");
	
	var _Pad2 = _interopRequireDefault(_Pad);
	
	var _Spacer = __webpack_require__("./src/components/blocks/Spacer.js");
	
	var _Spacer2 = _interopRequireDefault(_Spacer);
	
	var _Background = __webpack_require__("./src/components/blocks/Background.js");
	
	var _Background2 = _interopRequireDefault(_Background);
	
	var _Post = __webpack_require__("./src/components/Post.js");
	
	var _logofavcon2x = __webpack_require__("./assets/logofavcon@2x.png");
	
	var _logofavcon2x2 = _interopRequireDefault(_logofavcon2x);
	
	var _SocialTags = __webpack_require__("./src/components/atoms/SocialTags.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  var posts = props.data.allContentfulBlogPost.edges.map(function (e) {
	    return e.node;
	  });
	  posts.sort(function (a, b) {
	    return new Date(b.publishDate) > new Date(a.publishDate);
	  });
	  var blogPost = props.pathContext,
	      postIndex = posts.findIndex(function (post) {
	    return post.id === blogPost.id;
	  });
	  console.log(blogPost);
	  if (!blogPost.title) return "";
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      {
	        title: "Contraline News",
	        meta: [{ name: "Contraline", content: "News" }]
	      },
	      _react2.default.createElement("link", { rel: "icon", type: "image/png", href: _logofavcon2x2.default }),
	      _react2.default.createElement(_SocialTags.MetaTags, {
	        title: blogPost.title + " " + blogPost.subtitle,
	        description: blogPost.body && blogPost.body.body,
	        src: blogPost.headerImage && blogPost.headerImage.responsiveResolution.src
	      })
	    ),
	    _react2.default.createElement(_NavBar2.default, { color: "dark", background: "white" }),
	    _react2.default.createElement(
	      _Background2.default,
	      { color: "white", fixed: true },
	      _react2.default.createElement(
	        _Section2.default,
	        { noBorder: true, fixed: true, vPad: false },
	        _react2.default.createElement(
	          _Pad2.default,
	          { h: 2 },
	          _react2.default.createElement(_Post.PostFeature, { post: blogPost })
	        ),
	        _react2.default.createElement(
	          _Responsive.HideMobile,
	          null,
	          _react2.default.createElement(_Spacer2.default, { span: 2 })
	        ),
	        _react2.default.createElement(
	          _Pad2.default,
	          { v: 2, h: 2 },
	          _react2.default.createElement(
	            _Post.PostBody,
	            null,
	            _react2.default.createElement(
	              _reactMarkdown2.default,
	              { source: blogPost.body && blogPost.body.body },
	              blogPost.body && blogPost.body.body
	            ),
	            _react2.default.createElement(_Spacer2.default, { span: 2 }),
	            _react2.default.createElement(
	              _Flex2.default,
	              { style: { maxWidth: "45rem" }, align: "flex-start" },
	              _react2.default.createElement(
	                "div",
	                { style: { width: 300 } },
	                postIndex < posts.length - 1 && _react2.default.createElement(
	                  _Post.PostLink,
	                  { post: posts[postIndex + 1] },
	                  _react2.default.createElement(
	                    _typography.Description,
	                    { style: { paddingBottom: 0 } },
	                    "Previous",
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    _typography.P,
	                    { style: { fontWeight: 500 } },
	                    posts[postIndex + 1].title + " " + posts[postIndex + 1].subtitle
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { width: 300 } },
	                0 < postIndex && _react2.default.createElement(
	                  _Post.PostLink,
	                  { post: posts[postIndex - 1] },
	                  _react2.default.createElement(
	                    _typography.Description,
	                    { style: { paddingBottom: 0 } },
	                    "Next"
	                  ),
	                  _react2.default.createElement(
	                    _typography.P,
	                    { style: { fontWeight: 500 } },
	                    posts[postIndex - 1].title + " " + posts[postIndex - 1].subtitle
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Pad2.default, { v: 2 }),
	        _react2.default.createElement(_Spacer2.default, { span: 4 })
	      )
	    )
	  );
	};
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-news-post-js-4dcda5e4da6bb82b1e47.js